//Alertify
import 'alertifyjs/build/css/alertify.min.css'
import 'alertifyjs/build/css/themes/bootstrap.css'
import alertify from 'alertifyjs/build/alertify'
alertify.set('notifier', 'delay', 10)

$(function () {
	$('#contacto_form').on('submit', function (event) {
		event.preventDefault()

		let action = this.action
		$.post(
			action,
			$(this).serialize(),
			function (data, textStatus, jqXHR) {
				if (textStatus == 'success') {
					if (data && data.success) {
						alertify.success('Mensaje enviado')
					} else {
						alertify.error('error: ' + data.msg)
					}
				} else {
					alertify.error('error: No hay respuesta del servidor')
				}
			},
			'json'
		)
	})
})
